module.exports = __webpack_public_path__ + "assets/img/function4.2d4162a1.png";